import { useUnifiedBilling } from '../store/global-billing'
import { legacyPlanSunset, type LegacyPlanSunset } from '../utils/legacy-plan-sunset'

export function useLegacyPlanSunset(): LegacyPlanSunset | null {
  const { subscription, billingProfile } = useUnifiedBilling()

  return legacyPlanSunset(subscription, billingProfile)
}
